import Dashboard from '../Dashboard'
export const paths = [
    {
        path: '/',
        component: Dashboard
    }
]

export const DashboardRouters = {
    icon: 'home',
    testId: '',
    path: '/',
    label: 'Home',
    tree: []
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/routers.js